import { render, staticRenderFns } from "./app-spinner.vue?vue&type=template&id=1541330c&scoped=true&"
import script from "./app-spinner.vue?vue&type=script&lang=js&"
export * from "./app-spinner.vue?vue&type=script&lang=js&"
import style0 from "./app-spinner.vue?vue&type=style&index=0&id=1541330c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541330c",
  null
  
)

export default component.exports